import { Link } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";
import RepExample from "@/components/RepExample";
import PageMeta from "@/components/PageMeta";
import { SITE } from "@/config/site";
import { EnvelopeSimple, FileText } from "@phosphor-icons/react";

/**
 * Shared "page is being finalised" view used by /terms, /privacy, /loan-terms,
 * /responsible-lending, /cookies, /complaints, /struggling-to-repay, /careers.
 */
export default function LegalStub({ title, description, testid, children }) {
  return (
    <div className="min-h-screen bg-[#F9F7F4]">
      <PageMeta title={`${title} — Ascentremit`} description={description} />
      <PublicNav />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-16 py-14 lg:py-20" data-testid={testid}>
        <div className="inline-flex items-center gap-2 overline mb-4">
          <FileText size={14} weight="fill" /> Legal
        </div>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-[#132A13] font-medium leading-tight">
          {title}
        </h1>
        <p className="mt-6 text-base text-[#4F5D4F] leading-relaxed">
          This page is being finalised. Until it's published, you can reach us by email and we'll answer any
          question in writing.
        </p>
        <div className="mt-8 rounded-2xl bg-white border border-[#E5E3DB] p-5 flex items-start gap-3">
          <EnvelopeSimple size={20} weight="fill" className="text-[#0A3622] mt-0.5" />
          <div className="text-sm">
            <div className="font-semibold text-[#132A13]">Need an answer now?</div>
            <div className="text-[#4F5D4F] mt-1">
              Email <a href={`mailto:${SITE.SUPPORT_EMAIL}`} className="text-[#0A3622] underline">{SITE.SUPPORT_EMAIL}</a>
              {" "}or <Link to="/faq" className="text-[#0A3622] underline">read the FAQ</Link>.
            </div>
          </div>
        </div>
        {children}
      </section>
      <RepExample />
      <Footer />
    </div>
  );
}
